import { styled, Typography } from '@mui/material';

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.htmlFontSize,
  fontFamily: 'SourceSansPro-Bold',
  textWrap: 'balance',
  hyphens: 'auto'
}));
